import PageTitle from "../components/fragments/PageTitle"

const CasesPage = () => {
    return <PageTitle>Cases</PageTitle>
}

export default CasesPage